import { Link } from "react-router";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { ThemedButton } from "./ThemedButton";

type Props = {
  ariaLabel?: string;
  className?: string;
  onClick?: () => void;
  route?: string;
  text: string;
  truncate?: boolean;
  maskValue?: boolean;
};

const linkClassName = "text-text/interactive";

export const LinkTextButton = ({
  ariaLabel,
  className,
  onClick,
  route,
  text,
  truncate = false,
  maskValue = false,
}: Props) => {
  const content = maskValue ? <span data-ph-mask="">{text}</span> : text;

  if (isTruthy(route)) {
    return (
      <Link to={route}>
        <ThemedButton
          ariaLabel={ariaLabel}
          className={cnTwMerge(linkClassName, className)}
          dataTestId="text-button"
          truncate={truncate}
          variant="text"
        >
          {content}
        </ThemedButton>
      </Link>
    );
  }

  return (
    <ThemedButton
      ariaLabel={ariaLabel}
      className={cnTwMerge(linkClassName, className)}
      dataTestId="text-button"
      onClick={onClick}
      truncate={truncate}
      variant="text"
    >
      {content}
    </ThemedButton>
  );
};
